import { render, staticRenderFns } from "./breaks.vue?vue&type=template&id=149fd149&"
import script from "./breaks.vue?vue&type=script&lang=js&"
export * from "./breaks.vue?vue&type=script&lang=js&"
import style0 from "./breaks.vue?vue&type=style&index=0&id=149fd149&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports